<template>
  <div>
    <label class="text-input-label">
      {{getLabel}}
    </label>
    <v-text-field
    v-model="model"
    :rules="rules"
    dense
    :class="`sts-web-system-label ${disabled ? 'v-input--is-readonly' : ''}`"
    hide-details="auto"
    :disabled="disabled"
    :readonly="readonly"
    :outlined="outlined">
      <template #prepend>
        <v-icon
        v-if="icon"
        size="30"
        color="black">
          mdi-account
        </v-icon>
      </template>
    </v-text-field>
  </div>
</template>
<script>
export default {
  props: {
    icon: Boolean,
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    label: String,
    value: String
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    getLabel() {
      return `${this.label}${this.required ? "*": ""}`
    }
  },
  data() {
    return {
      rules: [
        (v) => this.required ? !!v || this.$t('invalidValue.required') : true
      ]
    }
  }
}
</script>
<style>
.sts-web-system-label  .v-label.theme--light {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
}
.sts-web-system-label  > div.v-input__control > div.v-input__slot > div.v-text-field__slot > input {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  color: black;
}
.normal-text-field.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 38px;
  border: 1px solid #49505742;
}
</style>